import { useHits } from "react-instantsearch-hooks-web";

const SingleResult = ({ hit }) => (
	<div className="flex flex-col md:flex-row gap-6 py-4">
		<div className="w-full md:w-1/2 overflow-hidden">
			{hit.photo ? (
				<img
					src={hit.photo}
					alt={hit.name}
					className="w-full h-full object-contain"
					loading="lazy"
				/>
			) : (
				<div className="w-full h-full flex items-center justify-center text-gray-400">
					No Image
				</div>
			)}
		</div>
		<div className="w-full md:w-1/2 flex flex-col justify-center">
			<h3 className="anton text-xl uppercase leading-tight">{hit.name}</h3>
			{hit.priceMin != null && (
				<p className="mt-2 text-2xl font-semibold">
					${Number(hit.priceMin).toLocaleString()}
				</p>
			)}
			{hit.description && (
				<div
					className="mt-4 text-sm text-gray-600 line-clamp-6 prose prose-sm max-w-none"
					dangerouslySetInnerHTML={{ __html: hit.description }}
				/>
			)}
			<a
				href={hit.url}
				className="mt-4 inline-block anton text-center bg-[#dd2c2c] text-white px-6 py-2 rounded-sm hover:bg-red-700 transition-colors w-fit"
			>
				VIEW DETAILS
			</a>
		</div>
	</div>
);

export const SearchResults = () => {
	const { hits } = useHits();
	const topHits = hits.slice(0, 8);

	if (topHits.length === 0) return null;

	if (topHits.length === 1) return <SingleResult hit={topHits[0]} />;

	return (
		<div>
			<h2 className="anton text-xl mb-4">SEARCH RESULTS</h2>
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 py-4">
				{topHits.map((hit) => (
					<a key={hit.objectID} href={hit.url} className="block group">
						<div className="aspect-square overflow-hidden">
							{hit.photo ? (
								<img
									src={hit.photo}
									alt={hit.name}
									className="w-full h-full object-contain"
									loading="lazy"
								/>
							) : (
								<div className="w-full h-full flex items-center justify-center text-gray-400">
									No Image
								</div>
							)}
						</div>
						<h3 className="anton text-[17px] mt-2 uppercase leading-tight">
							{hit.name}
						</h3>
						{hit.priceMin != null && (
							<p className="mt-1 font-semibold">
								${Number(hit.priceMin).toLocaleString()}
							</p>
						)}
					</a>
				))}
			</div>
		</div>
	);
};
